import * as yup from 'yup';

import { ObjectTypeBase } from '../../types/baseTypes/ObjectTypeBase';
import { MediaImageContentTypeEnum, MediaTypeEnum } from 'constants-media';
import { PropertiesInterface } from '../../types/properties/Property';
import { TypeContextEnum } from '../../types/properties/TypeContextEnum';
import Types from '../Types';
import { TYPE_GROUP_LANE } from '../constants';
import createShapeFromProperties from '../createShapeFromProperties';

const properties: PropertiesInterface = {
  _id: {
    type: 'UUID',
    validators: [
      {
        name: 'Required',
        value: true,
      },
    ],
  },
  type: {
    type: 'String',
    default: MediaTypeEnum.Image,
    validators: [
      {
        name: 'In',
        value: [MediaTypeEnum.Image],
      },
    ],
  },
  contentType: {
    type: 'String',
    validators: [
      {
        name: 'In',
        value: Object.values(MediaImageContentTypeEnum),
      },
    ],
  },
};

/**
 * @deprecated This class is deprecated and should not be used in new code.
 * Use ImageType from application-types instead.
 */
export class ImageType extends ObjectTypeBase {
  group = TYPE_GROUP_LANE;

  name = 'Image';

  friendlyName = 'Image';

  contexts = [TypeContextEnum.Block, TypeContextEnum.Content];

  get example() {
    return {
      _id: '000000AZFL4hDIULFpk8Vt',
    };
  }

  get default(): any {
    return null;
  }

  buildSchema() {
    return yup
      .object()
      .nullable()
      .default(null)
      .shape(createShapeFromProperties(properties));
  }

  properties = properties;
}

/**
 * @deprecated This constant is deprecated and should not be used in new code.
 * Use Image from application-types instead.
 */
const definition = new ImageType();

Types.addBaseType(definition);
export default definition;
